(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function hasAny(text, words) {
    return words.some(function (word) { return text.indexOf(word) !== -1; });
  }

  function blockLabel(block) {
    var label = block.querySelector('.lbx-option-label');
    return normalize(label ? label.textContent : '');
  }

  function blockValues(block) {
    return Array.prototype.slice.call(block.querySelectorAll('[data-lbx-option-button]')).map(function (button) {
      return normalize(button.getAttribute('data-lbx-option-value') || (button.querySelector('strong') && button.querySelector('strong').textContent) || button.textContent);
    }).join(' ');
  }

  function roleFor(block) {
    var label = blockLabel(block);
    var values = blockValues(block);

    if (hasAny(label, ['color', 'colour', 'farbe', 'couleur', 'colore', 'cor', 'kleur']) ||
      hasAny(values, ['braun', 'brown', 'marron', 'marron', 'blanco', 'weiss', 'white', 'blau', 'blue', 'azul', 'schwarz', 'black', 'negro', 'grun', 'gruen', 'green', 'verde', 'grau', 'gray', 'grey', 'gris', 'orange', 'naranja', 'morado', 'morada', 'violeta', 'purple', 'lavender', 'lavanda', 'lila', 'elderberry', 'rosa', 'pink', 'cobre', 'copper', 'bronce', 'bronze', 'dorado', 'gold', 'titanio', 'titanium', 'petrol', 'teal', 'turquesa', 'moss', 'musgo', 'sage', 'salvia', 'argile', 'khaki', 'champagne', 'champan', 'champán'])) {
      return 'color';
    }

    if (hasAny(label, ['talla', 'size', 'groesse', 'grosse', 'rahmengrosse', 'rahmen groesse', 'rahmen grosse', 'rahmengroesse', 'grande', 'taille', 'tamanho', 'maat']) ||
      /(^|\s)(xxs|xs|s|m|l|xl|xxl)(\s|$)/.test(values)) {
      return 'size';
    }

    if (hasAny(label, ['bateria', 'batterie', 'battery', 'akku', 'accu', 'autonomia', 'autonomy', 'reichweite', 'capacidad', 'range']) ||
      /(^|\s)([3456789][0-9]{2})\s*(w|wh)?(\s|$)/.test(values)) {
      return 'battery';
    }

    return '';
  }

  var colorMap = [
    { keys: ['elderberry', 'aubergine', 'berenjena'], color: '#5b2f5f' },
    { keys: ['lavender', 'lavanda', 'lila', 'lilac'], color: '#8b6fc8' },
    { keys: ['purple', 'purpura', 'purpura', 'púrpura', 'violeta', 'violet', 'morado', 'morada'], color: '#6f4aa2' },
    { keys: ['pink', 'rosa', 'rose'], color: '#d75b8c' },
    { keys: ['petrol', 'teal', 'turquoise', 'turquesa', 'aqua'], color: '#0f6f73' },
    { keys: ['navy', 'marine', 'marino', 'azul marino', 'dunkelblau'], color: '#172554' },
    { keys: ['blau', 'blue', 'azul', 'bleu', 'blu'], color: '#1d65d8' },
    { keys: ['moss', 'musgo', 'sage', 'salvia', 'argile', 'khaki'], color: '#6f7c55' },
    { keys: ['grun', 'gruen', 'green', 'verde', 'vert', 'olive', 'oliva'], color: '#3f6f4b' },
    { keys: ['burgundy', 'granate', 'burdeos', 'wine'], color: '#6f1d2a' },
    { keys: ['rot', 'red', 'rojo', 'roja', 'rouge', 'rosso'], color: '#b91c1c' },
    { keys: ['orange', 'naranja', 'arancione'], color: '#f97316' },
    { keys: ['gelb', 'yellow', 'amarillo', 'amarilla'], color: '#f3c735' },
    { keys: ['champagne', 'champan', 'champán'], color: '#d8c3a5' },
    { keys: ['beige', 'sand', 'arena', 'crema', 'cream', 'sable'], color: '#d8c3a5' },
    { keys: ['gold', 'dorado', 'oro'], color: '#c8a24a' },
    { keys: ['bronze', 'bronce'], color: '#9a6b34' },
    { keys: ['copper', 'cobre'], color: '#b87333' },
    { keys: ['brown', 'braun', 'marron', 'marrón', 'brun', 'cafe', 'café', 'chocolate'], color: '#8b5a34' },
    { keys: ['titanium', 'titanio'], color: '#9a958d' },
    { keys: ['silver', 'plata'], color: '#c8ccd2' },
    { keys: ['basalt', 'basalto', 'graphite', 'grafito', 'anthracite', 'antracita'], color: '#2b2d31' },
    { keys: ['grau', 'gray', 'grey', 'gris', 'grigio'], color: '#8f949a' },
    { keys: ['weiss', 'white', 'blanco', 'blanca', 'blanc', 'bianco'], color: '#f7f7f2' },
    { keys: ['schwarz', 'black', 'negro', 'negra', 'noir', 'nero'], color: '#15171c' }
  ];

  function swatchFor(value) {
    var n = normalize(value);
    for (var i = 0; i < colorMap.length; i += 1) {
      for (var j = 0; j < colorMap[i].keys.length; j += 1) {
        if (n.indexOf(colorMap[i].keys[j]) !== -1) return colorMap[i].color;
      }
    }
    return '';
  }

  function rangeFor(value) {
    return '';
  }

  function locale() {
    var lang = normalize(document.documentElement.lang || '');
    var path = normalize(location.pathname || '');
    if (lang.indexOf('de') === 0 || path.indexOf('de ') === 0 || path.indexOf('de eu') === 0) return 'de';
    if (lang.indexOf('fr') === 0 || path.indexOf('fr ') === 0) return 'fr';
    if (lang.indexOf('en') === 0 || path.indexOf('en ') === 0) return 'en';
    if (lang.indexOf('pt') === 0 || path.indexOf('pt ') === 0) return 'pt';
    return 'es';
  }

  function sizeGuideText() {
    var l = locale();
    if (l === 'de') return 'Welche Größe brauchst du?';
    if (l === 'fr') return 'Quelle taille vous faut-il ?';
    if (l === 'en') return 'What size do you need?';
    if (l === 'pt') return 'Qual é o teu tamanho?';
    return '¿Cuál es tu talla?';
  }


  function renderSizeGuideButton(button) {
    if (!button) return;
    var text = sizeGuideText();
    button.innerHTML = '<span class="lbx-size-guide-link-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16.5 16.5 4 20 7.5 7.5 20 4 16.5Z"></path><path d="M8 16 6.8 14.8"></path><path d="M10.5 13.5 9.3 12.3"></path><path d="M13 11 11.8 9.8"></path><path d="M15.5 8.5 14.3 7.3"></path></svg></span><span>' + text + '</span>';
  }

  function batterySubtitle() {
    var l = locale();
    if (l === 'de') return 'Reichweite';
    if (l === 'fr') return 'Autonomie';
    if (l === 'en') return 'Range';
    if (l === 'pt') return 'Autonomia';
    return 'Autonomía';
  }

  function ensureColor(button) {
    var value = button.getAttribute('data-lbx-option-value') || (button.querySelector('strong') && button.querySelector('strong').textContent) || button.textContent;
    button.classList.add('lbx-v30-swatch-button', 'lbx-color-button');
    var swatch = swatchFor(value);
    if (swatch) {
      button.style.setProperty('--lbx-swatch', swatch);
      button.style.setProperty('--lbx-v29-swatch', swatch);
      button.style.setProperty('--lbx-v30-swatch', swatch);
    }
    button.setAttribute('title', String(value).trim());
    button.setAttribute('aria-label', String(value).trim());
    if (!button.querySelector('.lbx-color-dot')) {
      var dot = document.createElement('span');
      dot.className = 'lbx-color-dot';
      dot.setAttribute('aria-hidden', 'true');
      button.appendChild(dot);
    }
  }



  function canonicalizeSizeGuide(block) {
    if (!block) return;
    var label = block.querySelector('.lbx-size-option-label, .lbx-option-label');
    if (!label) return;

    var buttons = Array.prototype.slice.call(block.querySelectorAll('button[data-lbx-size-guide-open], button.lbx-size-guide-link, button.lbx-v29-size-guide-link, button.lbx-v30-size-guide-link'));
    var preferred = buttons.filter(function (button) { return label.contains(button); })[0] || buttons[0];

    if (!preferred) {
      preferred = document.createElement('button');
      preferred.type = 'button';
      preferred.className = 'lbx-size-guide-link lbx-v29-size-guide-link lbx-v30-size-guide-link';
      preferred.setAttribute('data-lbx-size-guide-open', '');
      renderSizeGuideButton(preferred);
    }

    preferred.type = 'button';
    preferred.classList.add('lbx-size-guide-link', 'lbx-v30-size-guide-link');
    preferred.setAttribute('data-lbx-size-guide-open', '');

    if (!preferred.textContent || !preferred.textContent.trim()) {
      renderSizeGuideButton(preferred);
    }

    if (preferred.parentElement !== label) {
      label.appendChild(preferred);
    }

    buttons.forEach(function (button) {
      if (button !== preferred && block.contains(button)) button.remove();
    });
  }

  function ensureSize(block, button) {
    var strong = button.querySelector('strong');
    var value = button.getAttribute('data-lbx-option-value') || (strong && strong.textContent) || button.textContent;
    value = String(value || '').trim();
    button.classList.add('lbx-v30-size-button', 'lbx-size-button');
    if (!strong) {
      strong = document.createElement('strong');
      strong.textContent = value;
      button.insertBefore(strong, button.firstChild);
    }
    Array.prototype.slice.call(button.querySelectorAll('[data-lbx-size-card-range], span:not(.lbx-color-dot)')).forEach(function (span) {
      span.remove();
    });

    canonicalizeSizeGuide(block);
  }

  function ensureBattery(button) {
    button.classList.add('lbx-v30-battery-button');
    var strong = button.querySelector('strong');
    var value = button.getAttribute('data-lbx-option-value') || (strong && strong.textContent) || button.textContent;
    var clean = String(value || '').trim();
    if (strong && /^\d+$/.test(clean)) strong.textContent = clean + ' W';
    var span = button.querySelector('span');
    if (span) span.textContent = batterySubtitle();
  }

  function apply(root) {
    root = root || document;
    Array.prototype.slice.call(root.querySelectorAll('[id^="lbx-product-"] .lbx-option-block')).forEach(function (block) {
      var role = block.getAttribute('data-lbx-v30-role') || roleFor(block);
      if (!role) return;
      block.setAttribute('data-lbx-v30-role', role);
      if (role === 'color') {
        Array.prototype.slice.call(block.querySelectorAll('[data-lbx-option-button]')).forEach(ensureColor);
      } else if (role === 'size') {
        Array.prototype.slice.call(block.querySelectorAll('[data-lbx-option-button]')).forEach(function (button) { ensureSize(block, button); });
        canonicalizeSizeGuide(block);
      } else if (role === 'battery') {
        Array.prototype.slice.call(block.querySelectorAll('[data-lbx-option-button]')).forEach(ensureBattery);
      }
    });
  }

  function boot() {
    apply(document);
    [100, 350, 900, 1600].forEach(function (delay) { setTimeout(function () { apply(document); }, delay); });
    var observerQueued = false;
    function scheduleApply() {
      if (observerQueued) return;
      observerQueued = true;
      window.requestAnimationFrame(function () {
        observerQueued = false;
        apply(document);
      });
    }

    /* v908: observar solo el/los bloques de producto, no todo el documento. */
    Array.prototype.slice.call(document.querySelectorAll('[id^="lbx-product-"]')).forEach(function (root) {
      var observer = new MutationObserver(function () {
        scheduleApply();
      });
      observer.observe(root, { childList: true, subtree: true });
    });
    window.addEventListener('resize', scheduleApply, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleApply, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
